import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectGlobalState } from "../state-management/selectors";
import { addNews } from "../state-management/actions/news-actions";
import NewsComponent from "../components/news";
import { NewsDataProps } from "../types/public";
import {
  setAlert,
  setAlertSeverity,
  setAlertContext,
} from "../state-management/actions/alerts-actions";
import { addNotification } from "../state-management/actions/notification-actions";
import { createNotificationData } from "../utils/createNotificationData";

export default function AddNews() {
  const dispatch = useDispatch();
  const { currentUserData, groupingData, departmentsData } =
    useSelector(selectGlobalState);
  const initialData = {
    title: "",
    department_id: "",
    content: "",
    created_by: currentUserData._id,
    index_picture: "",
    tags: "",
    is_active: false,
    description: "",
  };
  const [formData, setFormData] = useState<NewsDataProps>(initialData);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values: NewsDataProps) => {
    try {
      setLoading(true);
      const data = {
        ...values,
        tags: values.tags?.split("،").map((tag: string) => tag.trim()),
      };
      const response = await addNews(data)(dispatch);
      if (response?.status === 200) {
        setFormData(initialData);
        dispatch(setAlert(true));
        dispatch(setAlertSeverity("success"));
        dispatch(setAlertContext("ثبت خبر با موفقیت صورت پذیرفت"));
        const notificationData = createNotificationData({
          data,
          departmentsData,
          currentUserData,
          groupingData,
          type: "create",
          subject: "خبر",
        });
        await addNotification(notificationData)(dispatch);
        return true;
      }
      return false;
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <NewsComponent
      handleSubmit={handleSubmit}
      formData={formData}
      setFormData={setFormData}
      currentUserId={currentUserData._id}
      loading={loading}
    />
  );
}
